import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

export default class AddOrganization extends React.Component {

    state = {
        open: false,
        organization: ""
    };

    handleChange = (e) =>  {
        const { value } = e.target;
        this.setState({ organization: value });
    }

    handleOpen = () => {
        this.setState({...this.state, open: true, organization: ""});
    };

    handleClose = () => {
        this.setState({...this.state, open: false, selected: -1});
    };

    handleAddClose = () => {
        if (this.state.organization) {
            this.props.handleClose(this.state.organization);
        }

        this.setState({...this.state, open: false}, this.handleClose);
    };

    componentWillReceiveProps(nextProps) {
        if(!nextProps.nodes)
            return;

        this.setState({
            ...this.state,
        });
    }

    render() {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleClose}
            />,
            <FlatButton
                label="Add"
                primary={true}
                keyboardFocused={true}
                onTouchTap={() => {
                    this.handleAddClose()
                    this.handleClose()
                }
                }
            />,
        ];

        return (
            <div>
                <RaisedButton label="Link organization" onTouchTap={this.handleOpen} />
                <Dialog
                    title="Link organization"
                    modal={false}
                    open={this.state.open}
                    autoScrollBodyContent={true}
                    actions={actions}
                    onRequestClose={this.handleClose}
                >
                    <div>
                        <TextField floatingLabelText="organization"
                                   value={this.state.organization}
                                   onChange={this.handleChange}>
                        </TextField>
                    </div>
                </Dialog>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/customerForm/AddOrganization.js